import React, { useState, useEffect } from 'react';
import Iframe from 'react-iframe';

const PDFViewer = ({
    showPdfIframe,
    uploadedDocumentUrl,
    documents,
    currentDocumentIndex,
    handlePreviousDocument,
    handleNextDocument,
    t
}) => {
    const [iframeKey, setIframeKey] = useState(0);
    const [readyUrl, setReadyUrl] = useState(null);

    // Force iframe reload when URL or index changes to prevent using revoked blob URLs
    // Add a small delay to ensure the blob URL is fully ready before loading
    useEffect(() => {
        if (uploadedDocumentUrl) {
            // Validate URL is still valid before setting
            if (typeof uploadedDocumentUrl === 'string' && uploadedDocumentUrl.startsWith('blob:')) {
                // Small delay to ensure URL is ready
                const timer = setTimeout(() => {
                    setReadyUrl(uploadedDocumentUrl);
                    setIframeKey(prev => prev + 1);
                }, 50);
                
                return () => clearTimeout(timer);
            } else {
                setReadyUrl(uploadedDocumentUrl);
                setIframeKey(prev => prev + 1);
            }
        } else {
            setReadyUrl(null);
        }
    }, [uploadedDocumentUrl, currentDocumentIndex]);

    if (!showPdfIframe || !readyUrl) return null;

    return (
        <div
            style={{
                flex: 1,
                marginLeft: '16px',
                minHeight: '600px',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                overflow: 'hidden',
                position: 'relative'
            }}
        >
            {/* Document Navigation - Left and Right arrows positioned on document edges */}
            {documents && documents.length > 0 && currentDocumentIndex > 0 && (
                <div
                    className="backIconBackground-edit"
                    onClick={handlePreviousDocument}
                    style={{
                        cursor: 'pointer',
                        padding: '8px',
                        borderRadius: '50%',
                        backgroundColor: '#304FFF',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'absolute',
                        left: '20px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 10,
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
                        transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#1E40FF';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#304FFF';
                    }}
                >
                    {/* Previous arrow SVG */}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path
                            d="M14.9995 15.875L11.1195 11.995L14.9995 8.11498C15.3895 7.72498 15.3895 7.09498 14.9995 6.70498C14.6095 6.31498 13.9795 6.31498 13.5895 6.70498L8.99953 11.295C8.60953 11.685 8.60953 12.315 8.99953 12.705L13.5895 17.295C13.9795 17.685 14.6095 17.685 14.9995 17.295C15.3795 16.905 15.3895 16.265 14.9995 15.875Z"
                            fill="white"
                        />
                    </svg>
                </div>
            )}
            
            {/* Document counter - positioned at top center */}
            {documents && documents.length > 1 && (
                <div style={{ 
                    position: 'absolute',
                    top: '60px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 10,
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    padding: '8px 16px',
                    borderRadius: '20px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
                    fontSize: '14px', 
                    fontWeight: '500', 
                    color: '#304FFF',
                    minWidth: '80px',
                    textAlign: 'center'
                }}>
                    {t('Document')} {currentDocumentIndex + 1} {t('of')} {documents.length}
                </div>
            )}
            
            {documents && documents.length > 0 && currentDocumentIndex < documents.length - 1 && (
                <div
                    className="backIconBackground-edit"
                    onClick={handleNextDocument}
                    style={{
                        cursor: 'pointer',
                        padding: '8px',
                        borderRadius: '50%',
                        backgroundColor: '#304FFF',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'absolute',
                        right: '20px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 10,
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
                        transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#1E40FF';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#304FFF';
                    }}
                >
                    {/* Next arrow SVG */}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path
                            d="M9.00047 15.875L12.8805 11.995L9.00047 8.11498C8.61047 7.72498 8.61047 7.09498 9.00047 6.70498C9.39047 6.31498 10.0205 6.31498 10.4105 6.70498L15.0005 11.295C15.3905 11.685 15.3905 12.315 15.0005 12.705L10.4105 17.295C10.0205 17.685 9.39047 17.685 9.00047 17.295C8.62047 16.905 8.61047 16.265 9.00047 15.875Z"
                            fill="white"
                        />
                    </svg>
                </div>
            )}
            <Iframe
                key={`pdf-viewer-${iframeKey}-${currentDocumentIndex}`}
                url={`${readyUrl}#page=1&view=FitH`}
                width="100%"
                height="100%"
                id={`import-manifest-document-${iframeKey}`}
                position="relative"
                title="Uploaded Document"
                allowFullScreen
            />
        </div>
    );
};

export default PDFViewer;